var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"nav-wrap",class:_vm.isTop ? 'navTop' : ''},[_c('img',{staticClass:"back-icon",attrs:{"src":require("@/assets/images/ico_fanhui@2x.png"),"alt":""},on:{"click":_vm.back}}),_c('div',{staticClass:"title"},[_vm._v(_vm._s(_vm.title)+" "),_vm._t("titleMode")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }